export default __webpack_public_path__ + "static/media/iphone-design-mobile.17e10458.png";